/**
 * Represents the list of FieldWrapped props for a React Hook Form based form
 * components.
 */
export const hookFormFieldWrapperProps = [
    'className',
    'description',
    'disabled',
    'helpIcon',
    'label',
    'noAlert',
    'noLabel',
    'style',
];
